module.exports = __webpack_public_path__ + "img/service_img03.b070536c.png";